import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api.js';
import { Aviso } from '../../componentes/ui.jsx';

/**
 * Funcao da Sofia: avisar o cliente 2 horas antes do horario marcado.
 *
 * Liga e desliga na hora, como a Avaliacao do Google (fica na mesma caixa de
 * automacoes). O envio fica na API (automacao/rotinas.js ›
 * enviarAvisosAntesSeForHora); o texto e editavel pelo DEV na tela de textos
 * (`lembrete.duas_horas`), como o lembrete de vespera.
 */
export function AvisoAntes({ agente }) {
  const ativo = Boolean(agente.config?.avisoAntes?.ativo);

  const queryClient = useQueryClient();
  const salvar = useMutation({
    mutationFn: (avisoAntes) => api.put('/api/ia/agentes/atendente', { config: { avisoAntes } }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['ia', 'agentes'] })
  });

  return (
    <>
      <div className="ci-automacao">
        <label className="ci-permissao crescer" title="Duas horas antes do horário marcado, a Sofia lembra o cliente pelo WhatsApp.">
          <input
            type="checkbox"
            checked={ativo}
            disabled={salvar.isPending}
            onChange={(e) => salvar.mutate({ ativo: e.target.checked })}
          />
          <span>
            AVISO 2 HORAS ANTES
            <small className="ci-automacao__descricao">
              Duas horas antes do horário, a Sofia lembra o cliente. Quem marcou em cima da hora não recebe.
            </small>
          </span>
        </label>
      </div>
      {salvar.isError && <Aviso tom="perigo">{salvar.error.message}</Aviso>}
    </>
  );
}
